/*
  NOTE: This file has been rewritten to use vanilla JavaScript instead of jQuery.
  Please do not add any code that requires jQuery or any other 3rd-party library.
*/

(function () {

  document.addEventListener("DOMContentLoaded", function () {


    /*
    --------------------------------------------------
    1. Remove empty elements
    --------------------------------------------------
    */

    document.querySelectorAll(
      "small.copyright__content, " +
      "h2.related-products__heading.inline-richtext.center.h3, " +
      ".mobile-facets__heading, " +
      ".related-products__heading"
    ).forEach(function (element) {

      if (
        !element.getAttribute("aria-label") &&
        !element.textContent.trim()
      ) {
        element.remove();
      }

    });



    /*
    --------------------------------------------------
    2. Add aria-live to form status messages
    --------------------------------------------------
    */

    document.querySelectorAll(
      ".form-status.form-status-list.form__message"
    ).forEach(function (element) {

      element.setAttribute(
        "aria-live",
        "assertive"
      );

    });



    /*
    --------------------------------------------------
    3. Back to Top button
    --------------------------------------------------
    */

    const backToTopButton =
      document.getElementById("back-to-top");


    if (backToTopButton) {


      backToTopButton.addEventListener(
        "click",
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });

        }
      );


      function scrollFunction() {

        if (
          document.body.scrollTop > 20 ||
          document.documentElement.scrollTop > 20
        ) {

          backToTopButton.style.display = "block";

        } else {

          backToTopButton.style.display = "none";

        }

      }


      function debounce(func, wait) {

        let timeout;

        return function (...args) {

          clearTimeout(timeout);

          timeout = setTimeout(function () {

            func.apply(this, args);

          }, wait);

        };

      }


      window.addEventListener(
        "scroll",
        debounce(scrollFunction, 100)
      );


      scrollFunction();

    }



    /*
    --------------------------------------------------
    4. Add image description accordion
    --------------------------------------------------
    */

    const targetSrc =
      "//getlawnbright.com/cdn/shop/files/White_and_Pink_Heart-Shaped_Photo_Collage_1.png?v=1613616959&width=3200";


    const image =
      document.querySelector(
        'img[src="' + targetSrc + '"]'
      );


    if (image) {


      const newHtml = `
      <div class="accordion">

        <details>

          <summary
            role="button"
            aria-expanded="false"
          >

            <span class="accordion__title inline-richtext h4">
              Image Description
            </span>

          </summary>


          <div
            class="accordion__content rte"
            role="region"
          >

            <p>
              The collage of images arranged in the shape of a heart.
              Each photo shows a young child playing outdoors.
              The children are engaged in activities like playing on a swing,
              sliding, playing with toys, and enjoying the grass.
            </p>

          </div>


        </details>

      </div>
      `;


      const mediaElement =
        image.closest(".media");


      if (mediaElement) {

        mediaElement.insertAdjacentHTML(
          "afterend",
          newHtml
        );

      }

    }



    /*
    --------------------------------------------------
    5. External / Third-Party Links
    --------------------------------------------------
    */


    const excludedLinks = [
      "/apps/collective/retailer-referral"
    ];



    function isExcludedLink(url) {

      return excludedLinks.some(function (excludedLink) {

        return url.includes(excludedLink);

      });

    }



    function isThirdPartyLink(url) {

      try {


        const linkUrl =
          new URL(
            url,
            window.location.origin
          );


        if (
          ["mailto:", "tel:", "javascript:"]
          .includes(linkUrl.protocol) ||
          url.startsWith("#")
        ) {

          return false;

        }


        const currentHostname =
          window.location.hostname
          .replace(/^www\./, "")
          .toLowerCase();


        const linkHostname =
          linkUrl.hostname
          .replace(/^www\./, "")
          .toLowerCase();


        return (
          linkHostname !== currentHostname
        );


      } catch (error) {

        return false;

      }

    }



    document.querySelectorAll(
      "a[href]"
    ).forEach(function (link) {


      const href =
        link.getAttribute("href");


      if (
        !href ||
        isExcludedLink(href)
      ) {

        return;

      }



      /*
      Internal links
      Remove target blank
      */

      if (!isThirdPartyLink(href)) {


        link.removeAttribute(
          "target"
        );


        const rel =
          link.getAttribute("rel");


        if (rel) {


          const updatedRel =
            rel
            .split(/\s+/)
            .filter(function(value){

              return (
                value !== "noopener" &&
                value !== "noreferrer"
              );

            })
            .join(" ");


          if (updatedRel) {

            link.setAttribute(
              "rel",
              updatedRel
            );

          } else {

            link.removeAttribute(
              "rel"
            );

          }

        }


        return;

      }




      /*
      Third-party links
      */

      link.setAttribute(
        "target",
        "_blank"
      );


      link.setAttribute(
        "rel",
        "noopener noreferrer"
      );



      const existingLabel =
        link.getAttribute(
          "aria-label"
        );


      const visibleText =
        link.textContent
        .trim()
        .replace(/\s+/g, " ");


      const linkText =
        existingLabel || visibleText;



      if (
        linkText &&
        !linkText.includes(
          "Redirecting to a third-party website"
        )
      ) {


        link.setAttribute(
          "aria-label",
          linkText +
          " Redirecting to a third-party website, opens in a new tab"
        );

      }



      const img =
        link.querySelector("img");


      if (img) {


        const alt =
          img.getAttribute("alt");


        if (
          alt &&
          !alt.includes(
            "Redirecting to a third-party website"
          )
        ) {


          img.setAttribute(
            "alt",
            alt +
            " Redirecting to a third-party website, opens in a new tab"
          );

        }

      }


    });




    /*
    --------------------------------------------------
    6. reCAPTCHA Accessibility
    --------------------------------------------------
    */


    const intervalID =
      window.setInterval(function () {


        const textAreaCheck =
          document.getElementsByClassName(
            "g-recaptcha-response"
          );


        if (textAreaCheck.length > 0) {


          Array.prototype.forEach.call(
            textAreaCheck,
            function(element){

              element.setAttribute(
                "aria-labelledby",
                "g-recaptcha-response"
              );

            }
          );


          clearInterval(
            intervalID
          );

        }


      }, 50);



  });


})();

document.addEventListener("DOMContentLoaded", function () {
  const backToTop = document.querySelector("#back-to-top");
  const backBtn = document.querySelector("#back-btn");

  if (backToTop && backBtn) {
    backToTop.addEventListener("click", function () {
      setTimeout(function () {
        backBtn.focus();
      }, 100);
    });
  }
})

document.addEventListener("DOMContentLoaded", function () {

  // Add aria-label for phone number
  const phoneLink = document.querySelector('a[href^="tel:"]');

  if (phoneLink) {
    const phoneText = phoneLink.textContent.trim();
    phoneLink.setAttribute("aria-label", `Phone Number, ${phoneText}`);
  }

  // Add aria-label for email
  const emailLink = document.querySelector('a[href^="mailto:"]');

  if (emailLink) {
    const emailText = emailLink.textContent.trim();
    emailLink.setAttribute("aria-label", `Email Address, ${emailText}`);
  }

});